/** The app font. Loaded from Google Fonts in public/index.html. */
export const FONT_FAMILY = '"Noto Sans", "Helvetica Neue", Arial, sans-serif';
